import React from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import Icon from '../atoms/Icon';
import Property from '../atoms/Property';
import styles from '../../styles/components/molecules/ItemLine.module.scss';

interface ItemLineProps {
  className?: string;
  type?: string;
  label?: string;
  ago?: string;
  status?: string;
  promoted?: boolean;
  memberships?: string[];
  rating?: number;
  rateCnt?: number;
}

export default function ItemLine(props: ItemLineProps) {
  const {
    promoted,
    type,
    label,
    ago,
    status,
    memberships,
    rating,
    rateCnt,
    className,
  } = props;
  const { t } = useTranslation([
    'common',
    'venue',
    'service',
    'rating',
    'request',
  ]);
  const classes = clsx(styles.itemLine, className);

  return (
    <ul className={classes}>
      {!!ago && (
        <li>
          <Property icon={'received'} value={ago} />
        </li>
      )}
      {!!type && (
        <li>
          <Property dark icon={type} value={label || t(`${type}:label`)} />
        </li>
      )}

      {!!status && (
        <li>
          <Property dark icon={status} value={t(`request:${status}`)} />
        </li>
      )}
      {!!promoted && (
        <li>
          <Property dark icon={'promoted'} value={t(`common:promoted`)} />
        </li>
      )}
      {!!rating && (
        <li>
          <Property
            onClick={() => alert()}
            icon={'rating'}
            value={`${rating}`}
            unit={`(${rateCnt})`}
          />
        </li>
      )}
      {(memberships || []).map((el: string, i: number) => (
        <li key={el} className={styles.member}>
          <Icon name={el} />
        </li>
      ))}
    </ul>
  );
}
